import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fb-view',
  templateUrl: './fb-view.component.html',
  styleUrls: ['./fb-view.component.css']
})
export class FbViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
